// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"377":"e3363abc","736":"314025df","879":"88ac9d4a","927":"df849ce1"}[chunkId] + ".chunk.css";
};